import { NavLink, Outlet } from 'react-router-dom';

import { 
    ChartBarIcon, 
    SquaresPlusIcon, 
    UserGroupIcon, 
    ArrowLeftOnRectangleIcon, 
    ClipboardDocumentListIcon,
    VideoCameraIcon,
    PresentationChartBarIcon,
    ShoppingBagIcon,
    ShoppingCartIcon // ✅ ADD THIS IMPORT
} from '@heroicons/react/24/solid';
import { useAuth } from '../../context/AuthContext';

// Reusable navigation link component for the admin sidebar
const AdminNavLink = ({ to, icon, children }) => (
  <NavLink
    to={to}
    end
    className={({ isActive }) =>
      `flex items-center px-4 py-3 text-lg font-medium rounded-lg transition-colors duration-200 ${
        isActive
          ? 'bg-orange-500 text-white shadow-md'
          : 'text-gray-600 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700'
      }`
    }
  >
    {icon}
    <span className="ml-3">{children}</span>
  </NavLink>
);

export default function AdminDashboardLayout() {
  const { user, logout } = useAuth();
  const userName = user?.first_name || 'Admin';

  return (
    <div className="min-h-screen flex bg-gray-100 dark:bg-gray-900">
      {/* --- Sidebar --- */}
      <aside className="w-64 flex-shrink-0 bg-white dark:bg-gray-800 shadow-lg flex flex-col">
        <div className="h-20 flex items-center justify-center border-b border-gray-200 dark:border-gray-700 px-4">
            <span className="text-2xl font-bold text-orange-500">Admin Panel</span>
        </div>
        <nav className="flex-grow p-4 space-y-2">
          <AdminNavLink to="/admin/dashboard" icon={<ChartBarIcon className="w-6 h-6" />}>Dashboard</AdminNavLink>
          <AdminNavLink to="/admin/campaigns" icon={<ClipboardDocumentListIcon className="w-6 h-6" />}>All Campaigns</AdminNavLink>
          
          {/* ✅ ADDED NEW LINK FOR PURCHASED ITEMS */}
          <AdminNavLink to="/admin/purchased-items" icon={<ShoppingCartIcon className="w-6 h-6" />}>Purchased Items</AdminNavLink>
          
          <AdminNavLink to="/admin/organizations" icon={<UserGroupIcon className="w-6 h-6" />}>Organizations</AdminNavLink>
          <AdminNavLink to="/admin/products" icon={<SquaresPlusIcon className="w-6 h-6" />}>Manage Products</AdminNavLink>
          <AdminNavLink to="/admin/organizations/:orgId/products" icon={<ShoppingBagIcon className="w-6 h-6" />}>Organization Products</AdminNavLink>
          <AdminNavLink to="/admin/users" icon={<UserGroupIcon className="w-6 h-6" />}>Manage Users</AdminNavLink>
          <AdminNavLink to="/admin/success-stories" icon={<VideoCameraIcon className="w-6 h-6" />}>Success Stories</AdminNavLink>
          <AdminNavLink to="/admin/stats" icon={<PresentationChartBarIcon className="w-6 h-6" />}>Manage Stats</AdminNavLink>
        </nav>
        <div className="p-4 border-t border-gray-200 dark:border-gray-700">
            <p className="text-center font-semibold text-gray-800 dark:text-gray-200 truncate">{userName}</p>
            <p className="text-center text-xs text-gray-500 dark:text-gray-400">Administrator</p>
            <button 
                onClick={logout} 
                className="w-full mt-4 flex items-center justify-center px-4 py-2 text-sm font-medium text-red-600 dark:text-red-400 rounded-lg hover:bg-red-50 dark:hover:bg-red-900/50 transition-colors"
            >
                <ArrowLeftOnRectangleIcon className="w-5 h-5" />
                <span className="ml-2">Log Out</span>
            </button>
        </div>
      </aside>

      {/* --- Main Content Area --- */}
      <main className="flex-grow p-6 md:p-10 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}